module.exports = __webpack_public_path__ + "img/p-solution.02cf7c45.jpg";